import { render, staticRenderFns } from "./editLiaison.vue?vue&type=template&id=20f5e693&scoped=true"
import script from "./editLiaison.vue?vue&type=script&lang=js"
export * from "./editLiaison.vue?vue&type=script&lang=js"
import style0 from "./editLiaison.vue?vue&type=style&index=0&id=20f5e693&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f5e693",
  null
  
)

export default component.exports